import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.min"
import i18n from "@/localization"
import communicator from './plugins/CommunicatorPlugin'

Vue.config.productionTip = false
Vue.use(communicator);

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
